// Madesa AJAX Filters and Collection Controls
(function() {
  function parseMainCollectionI18n() {
    const defaults = {
      active_filters_title: 'Active filters',
      clear_all: 'Clear all',
      apply_filters: 'Apply filters'
    };
    const el = document.getElementById('madesa-main-collection-i18n');
    if (!el || !String(el.textContent || '').trim()) {
      return defaults;
    }
    try {
      const parsed = JSON.parse(el.textContent);
      const out = { ...defaults };
      for (const key of Object.keys(parsed)) {
        if (parsed[key] != null && parsed[key] !== '') {
          out[key] = parsed[key];
        }
      }
      return out;
    } catch (error) {
      return defaults;
    }
  }

  const mainCollectionI18n = parseMainCollectionI18n();
  const filterTrigger = document.querySelector('.madesa-filter-trigger');
  const mobileFilterBtn = document.querySelector('.mobile-filter-btn');
  const filterDrawer = document.querySelector('.madesa-filter-drawer');
  const filterCloseBtn = document.querySelector('.filter-close-btn');
  const filterOverlay = document.querySelector('.filter-drawer-overlay');
  const filterForm = document.getElementById('madesa-filter-form');
  const clearFiltersBtn = document.getElementById('clear-filters-btn');

  // Sort modal elements
  const mobileSortBtn = document.querySelector('.mobile-sort-btn');
  const sortModal = document.getElementById('madesa-sort-modal');
  const sortModalClose = document.querySelector('.sort-modal-close');
  const sortModalOverlay = document.querySelector('.sort-modal-overlay');
  const sortModalRadios = document.querySelectorAll('input[name="sort_by_modal"]');

  if (!filterDrawer || !filterForm) return;

  const filterStrings = {
    active_filters_title:
      filterForm.dataset.filtersActiveTitle || mainCollectionI18n.active_filters_title,
    clear_all: filterForm.dataset.filtersClearAll || mainCollectionI18n.clear_all,
    apply_filters: filterForm.dataset.filtersApply || mainCollectionI18n.apply_filters
  };

  function getSectionId() {
    const fromResults = document.querySelector('results-list[section-id]')?.getAttribute('section-id');
    if (fromResults) return String(fromResults).replace(/^shopify-section-/, '');
    const sectionEl = document.getElementById('madesa-filter-form')?.closest('.shopify-section');
    if (sectionEl?.id) return sectionEl.id.replace(/^shopify-section-/, '');
    return null;
  }

  function isSearchCollectionHydrateMode() {
    return Boolean(filterForm?.dataset?.hydrateFiltersFrom);
  }

  function getSearchFormParams() {
    const q = filterForm.querySelector('[name="q"]')?.value || '';
    const type = filterForm.querySelector('[name="type"]')?.value || 'product';
    const handle = filterForm.querySelector('[name="collection_handle"]')?.value || '';
    const prefix = filterForm.querySelector('[name="options[prefix]"]')?.value || '';
    return { q, type, handle, prefix };
  }

  function collectionUrlToSearchUrl(collectionHref) {
    const searchBase = filterForm.dataset.collectionUrl || '/search';
    const { q, type, handle, prefix } = getSearchFormParams();
    let collUrl;

    try {
      collUrl = new URL(collectionHref, window.location.origin);
    } catch (e) {
      return collectionHref;
    }

    const searchUrl = new URL(searchBase, window.location.origin);
    if (q) searchUrl.searchParams.set('q', q);
    searchUrl.searchParams.set('type', type);
    if (handle) searchUrl.searchParams.set('collection_handle', handle);
    if (prefix) searchUrl.searchParams.set('options[prefix]', prefix);

    collUrl.searchParams.forEach((value, key) => {
      if (key.startsWith('filter.') || key === 'sort_by' || key === 'page') {
        searchUrl.searchParams.append(key, value);
      }
    });

    return searchUrl.pathname + searchUrl.search;
  }

  function rewriteCollectionLinksToSearch(container) {
    if (!container) return;
    container.querySelectorAll('a[href]').forEach((link) => {
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#')) return;
      try {
        const url = new URL(href, window.location.origin);
        if (url.pathname.includes('/collections/')) {
          link.setAttribute('href', collectionUrlToSearchUrl(href));
        }
      } catch (e) {
        /* ignore malformed href */
      }
    });
  }

  function rememberCollectionSectionId(sectionEl) {
    if (!sectionEl?.id) return;
    filterForm.dataset.hydrateSectionId = sectionEl.id.replace(/^shopify-section-/, '');
  }

  function buildCollectionProductsFetchUrl(queryInput) {
    const collectionPath = filterForm.dataset.hydrateFiltersFrom;
    const url = new URL(collectionPath, window.location.origin);
    const paramString = String(queryInput || '').replace(/^\?/, '');
    const params = paramString ? new URLSearchParams(paramString) : new URLSearchParams(getFormData());

    params.forEach((value, key) => {
      if (key.startsWith('filter.') || key === 'sort_by' || key === 'page') {
        url.searchParams.append(key, value);
      }
    });

    const hydrateSectionId = filterForm.dataset.hydrateSectionId;
    if (hydrateSectionId) {
      url.searchParams.set('section_id', hydrateSectionId);
    }
    return url.toString();
  }

  function parseCollectionSectionResponse(html) {
    let sectionHtml = html;
    const trimmed = html.trim();
    if (trimmed.startsWith('{')) {
      try {
        const data = JSON.parse(trimmed);
        sectionHtml = data[Object.keys(data)[0]] || '';
      } catch (e) {
        sectionHtml = html;
      }
    }

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = sectionHtml;
    let root =
      getRenderedSectionRoot(tempDiv, filterForm.dataset.hydrateSectionId) || tempDiv;

    if (!root.querySelector('#madesa-product-list') && /<html/i.test(html)) {
      root = extractFilterSectionFromPage(html);
    } else {
      const sectionEl = root.querySelector?.('.shopify-section') || (root.id?.startsWith('shopify-section-') ? root : null);
      if (sectionEl) rememberCollectionSectionId(sectionEl);
    }

    return root;
  }

  function applySearchCollectionListingFromSection(sectionRoot) {
    const currentProductList = getScopedProductList();
    const newProductList = sectionRoot.querySelector('#madesa-product-list');
    if (newProductList && currentProductList) {
      currentProductList.innerHTML = newProductList.innerHTML;
      if (currentProductList.closest('.madesa-search-results')) {
        currentProductList.dispatchEvent(new CustomEvent('madesa:search-list-refresh', { bubbles: false }));
      }
    }

    const currentPagination = getScopedPagination();
    const newPagination = sectionRoot.querySelector('#madesa-pagination');
    if (currentPagination) {
      if (newPagination) {
        currentPagination.innerHTML = newPagination.innerHTML;
        currentPagination.style.display = '';
        rewriteCollectionLinksToSearch(currentPagination);
        bindSearchCollectionPaginationLinks();
      } else {
        currentPagination.innerHTML = '';
        currentPagination.style.display = 'none';
      }
    }

    const newCount = sectionRoot.querySelector('.madesa-collection-count .count-highlight');
    const searchCount = document.querySelector('.madesa-collection-info .count-highlight');
    if (newCount && searchCount) {
      searchCount.textContent = newCount.textContent;
    }
  }

  function bindSearchCollectionPaginationLinks() {
    const currentPagination = getScopedPagination();
    if (!currentPagination || !isSearchCollectionHydrateMode()) return;
    currentPagination.querySelectorAll('a.pagination-item, a.pagination-arrow').forEach((link) => {
      if (link.dataset.searchCollectionBound === '1') return;
      link.dataset.searchCollectionBound = '1';
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const href = link.getAttribute('href');
        if (!href) return;
        try {
          const url = new URL(href, window.location.origin);
          applyFilters(url.search);
        } catch (err) {
          /* ignore malformed href */
        }
      });
    });
  }

  function buildCollectionFiltersFetchUrl() {
    const collectionPath = filterForm.dataset.hydrateFiltersFrom;
    const url = new URL(collectionPath, window.location.origin);

    const currentParams = new URLSearchParams(window.location.search);
    currentParams.forEach((value, key) => {
      if (key.startsWith('filter.') || key === 'sort_by') {
        url.searchParams.append(key, value);
      }
    });

    return url.toString();
  }

  function extractFilterSectionFromPage(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const filterFormEl = doc.querySelector('#madesa-filter-form');
    if (filterFormEl) {
      const section = filterFormEl.closest('.shopify-section');
      if (section) rememberCollectionSectionId(section);
      return section || filterFormEl;
    }
    return doc.querySelector('.madesa-collection-content-wrapper') || doc.body;
  }

  function applyHydratedFilterSection(source) {
    let sectionRoot;
    if (typeof source === 'string') {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = source;
      sectionRoot = getRenderedSectionRoot(tempDiv) || tempDiv;
    } else {
      sectionRoot = source;
    }

    const filterGroups = document.querySelector('.filter-groups');
    const newFilterGroups = sectionRoot.querySelector('.filter-groups');
    if (filterGroups && newFilterGroups) {
      filterGroups.innerHTML = newFilterGroups.innerHTML;
      filterGroups.removeAttribute('data-awaiting-hydration');
      rewriteCollectionLinksToSearch(filterGroups);
    }

    const activeFiltersContainer = document.getElementById('madesa-active-filters');
    const newActiveFilters = sectionRoot.querySelector('#madesa-active-filters');
    if (activeFiltersContainer && newActiveFilters) {
      activeFiltersContainer.innerHTML = newActiveFilters.innerHTML;
      rewriteCollectionLinksToSearch(activeFiltersContainer);
    }

    const filterHeaderBadge = document.querySelector('.filter-header-content .filter-count-badge');
    const newFilterHeader = sectionRoot.querySelector('.filter-header-content');
    const newHeaderBadge = newFilterHeader?.querySelector('.filter-count-badge');
    if (filterHeaderBadge) {
      if (newHeaderBadge) {
        filterHeaderBadge.textContent = newHeaderBadge.textContent;
        filterHeaderBadge.style.display = 'flex';
      } else {
        filterHeaderBadge.style.display = 'none';
      }
    } else if (newHeaderBadge) {
      const headerContent = document.querySelector('.filter-header-content');
      if (headerContent) {
        const badge = document.createElement('span');
        badge.className = 'filter-count-badge';
        badge.textContent = newHeaderBadge.textContent;
        headerContent.appendChild(badge);
      }
    }

    const newTriggerBadge = sectionRoot.querySelector('.madesa-filter-trigger .filter-count-badge');
    const triggerBadge = document.querySelector('.madesa-filter-trigger .filter-count-badge');
    if (triggerBadge) {
      if (newTriggerBadge) {
        triggerBadge.textContent = newTriggerBadge.textContent;
        triggerBadge.style.display = '';
      } else {
        triggerBadge.style.display = 'none';
      }
    } else if (newTriggerBadge) {
      const trigger = document.querySelector('.madesa-filter-trigger .filter-trigger-content');
      if (trigger?.parentElement) {
        const badge = document.createElement('span');
        badge.className = 'filter-count-badge';
        badge.textContent = newTriggerBadge.textContent;
        trigger.parentElement.appendChild(badge);
      }
    }

    updateFilterCount();
  }

  let hydrateFiltersPromise = null;

  async function hydrateFiltersFromCollection() {
    if (!isSearchCollectionHydrateMode()) return;

    if (hydrateFiltersPromise) return hydrateFiltersPromise;

    hydrateFiltersPromise = (async () => {
      const filterGroups = document.querySelector('.filter-groups');
      if (!filterGroups) return;

      try {
        const response = await fetch(buildCollectionFiltersFetchUrl());
        const html = await response.text();
        const sectionRoot = extractFilterSectionFromPage(html);
        if (sectionRoot) {
          applyHydratedFilterSection(sectionRoot);
        }
      } catch (error) {
        console.error('Error hydrating search collection filters:', error);
      } finally {
        filterGroups.removeAttribute('data-awaiting-hydration');
      }
    })();

    return hydrateFiltersPromise;
  }

  function getRenderedSectionRoot(fragment, sectionIdValue) {
    const sid = sectionIdValue || getSectionId();
    if (!fragment || !sid) return fragment;
    const raw = String(sid).replace(/^shopify-section-/, '');
    const esc =
      typeof CSS !== 'undefined' && typeof CSS.escape === 'function'
        ? CSS.escape(raw)
        : raw.replace(/([^\w-])/g, '\\$1');
    const wrapped = fragment.querySelector('#shopify-section-' + esc);
    return wrapped || fragment;
  }

  function buildFilterRequestUrl(params, sectionIdValue) {
    const url = new URL(window.location.pathname, window.location.origin);
    url.search = '';
    const raw = params == null ? '' : String(params);
    const query = raw.startsWith('?') ? raw.slice(1) : raw;
    if (query) {
      const parsed = new URLSearchParams(query);
      parsed.forEach((value, key) => {
        url.searchParams.append(key, value);
      });
    }
    url.searchParams.set('section_id', sectionIdValue);
    return url.toString();
  }

  function updateCollectionCount(sectionRoot) {
    const newCount = sectionRoot.querySelector('.madesa-collection-count .count-highlight');
    const currentCount = document.querySelector('.madesa-collection-count .count-highlight');
    if (newCount && currentCount) {
      currentCount.innerHTML = newCount.innerHTML;
    }
  }

  // Check if desktop (filters always visible)
  function isDesktop() {
    return window.innerWidth >= 750;
  }

  // Drawer controls
  function openDrawer() {
    if (isDesktop()) return; // Don't toggle on desktop
    filterDrawer.setAttribute('aria-hidden', 'false');
    if (filterTrigger) filterTrigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (isDesktop()) return; // Don't toggle on desktop
    filterDrawer.setAttribute('aria-hidden', 'true');
    if (filterTrigger) filterTrigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  // Initialize drawer state based on viewport
  function initDrawerState() {
    if (isDesktop()) {
      filterDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = '';
    } else {
      filterDrawer.setAttribute('aria-hidden', 'true');
    }
  }

  // Initialize on load
  initDrawerState();

  // Re-initialize on resize
  let resizeTimer;
  let windowWidth = window.innerWidth;

  window.addEventListener('resize', () => {
  if (window.innerWidth !== windowWidth) {
      windowWidth = window.innerWidth;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(initDrawerState, 250);
    }
  });

  // Filter drawer controls
  filterTrigger?.addEventListener('click', openDrawer);
  mobileFilterBtn?.addEventListener('click', openDrawer);
  filterCloseBtn?.addEventListener('click', closeDrawer);
  filterOverlay?.addEventListener('click', closeDrawer);

  // Sort modal controls
  function openSortModal() {
    if (sortModal) {
      sortModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeSortModal() {
    if (sortModal) {
      sortModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }

  mobileSortBtn?.addEventListener('click', openSortModal);
  sortModalClose?.addEventListener('click', closeSortModal);
  sortModalOverlay?.addEventListener('click', closeSortModal);

  // Handle sort selection in modal
  sortModalRadios.forEach(radio => {
    radio.addEventListener('change', () => {
      if (radio.checked) {
        const sortValue = radio.value;
        
        // Update desktop select if exists
        const desktopSelect = document.getElementById('madesa-sort-select');
        if (desktopSelect) {
          desktopSelect.value = sortValue;
        }
        
        syncMadesaManualRangeInputs(filterForm);
        const filterParams = getFormData();
        
        // Build URL with both filters and sort
        const url = new URL(window.location.href);
        url.search = ''; // Clear existing params
        
        // Add filter params
        if (filterParams) {
          const params = new URLSearchParams(filterParams);
          params.forEach((value, key) => {
            url.searchParams.append(key, value);
          });
        }
        
        // Add sort param
        url.searchParams.set('sort_by', sortValue);
        
        // Apply with combined parameters
        applyFilters(url.search);
        
        // Close modal
        closeSortModal();
      }
    });
  });

  // Close on Escape key (mobile only)
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if (!isDesktop() && filterDrawer.getAttribute('aria-hidden') === 'false') {
        closeDrawer();
      }
      if (sortModal && sortModal.getAttribute('aria-hidden') === 'false') {
        closeSortModal();
      }
    }
  });

  // AJAX Filter functionality
  let debounceTimers = {};
  
  function debounce(func, delay, key = 'default') {
    clearTimeout(debounceTimers[key]);
    debounceTimers[key] = setTimeout(func, delay);
  }

  function restorePriceRangeInputNames(form) {
    if (!form) return;
    form.querySelectorAll('price-range').forEach((el) => {
      if (typeof el.restorePriceRangeInputNames === 'function') {
        el.restorePriceRangeInputNames();
      }
    });
  }

  function getCollectionScope() {
    const form = document.getElementById('madesa-filter-form');
    if (!form) return null;
    return (
      form.closest('results-list') ||
      form.closest('.madesa-collection-mobile') ||
      form.closest('.shopify-section')
    );
  }

  function getScopedProductList() {
    const scope = getCollectionScope();
    if (!scope) return null;
    return (
      scope.querySelector('.madesa-products-container .madesa-product-list') ||
      scope.querySelector('.madesa-product-list')
    );
  }

  function getScopedPagination() {
    const scope = getCollectionScope();
    return scope?.querySelector('#madesa-pagination') || null;
  }

  function getLiveFilterForm() {
    return document.getElementById('madesa-filter-form');
  }

  function getFormData() {
    const liveForm = getLiveFilterForm();
    if (!liveForm) return '';
    const formData = new FormData(liveForm);
    const params = new URLSearchParams();

    for (const [key, value] of formData.entries()) {
      if (value) {
        params.append(key, value);
      }
    }

    const sortSelect = document.getElementById('madesa-sort-select');
    if (sortSelect?.value) {
      params.set('sort_by', sortSelect.value);
    }

    const q = params.toString();
    restorePriceRangeInputNames(liveForm);
    return q;
  }

  function syncMadesaManualRangeInputs(form) {
    if (!form) return;
    form.querySelectorAll('price-range').forEach((el) => {
      if (typeof el.applyManualValuesBeforeSubmit === 'function') {
        el.applyManualValuesBeforeSubmit();
      }
      if (typeof el.suppressFullRangePriceParams === 'function') {
        el.suppressFullRangePriceParams();
      }
    });
    form.querySelectorAll('list-range').forEach((el) => {
      if (typeof el.applyManualValuesBeforeSubmit === 'function') {
        el.applyManualValuesBeforeSubmit();
      }
    });
  }

  function getOpenFilterGroupTitles() {
    const liveFilterForm = document.getElementById('madesa-filter-form');
    if (!liveFilterForm) return new Set();
    const openTitles = new Set();
    liveFilterForm.querySelectorAll('.filter-groups details.filter-group[open]').forEach((details) => {
      const title = details.querySelector('.filter-group-title')?.textContent?.trim();
      if (title) openTitles.add(title);
    });
    return openTitles;
  }

  function restoreOpenFilterGroupTitles(openTitles) {
    const liveFilterForm = document.getElementById('madesa-filter-form');
    if (!liveFilterForm || !(openTitles instanceof Set) || openTitles.size === 0) return;
    liveFilterForm.querySelectorAll('.filter-groups details.filter-group').forEach((details) => {
      const title = details.querySelector('.filter-group-title')?.textContent?.trim();
      if (title && openTitles.has(title)) {
        details.setAttribute('open', '');
      }
    });
  }

  function ensureMadesaRangeWidgetsReady(root) {
    if (!root) return;
    root.querySelectorAll('price-range, list-range').forEach((el) => {
      if (el._madesaRangeInitialized) return;
      try {
        if (typeof el.connectedCallback === 'function') {
          el.connectedCallback();
        }
      } catch (error) {
        console.error('Madesa filters: failed to initialize range widget', error);
      }
    });
  }

  function updateFilterGroups(sectionRoot) {
    const liveFilterForm = document.getElementById('madesa-filter-form');
    if (!liveFilterForm) return;
    const currentGroups = liveFilterForm.querySelector('.filter-groups');
    const newGroups = sectionRoot.querySelector('#madesa-filter-form .filter-groups') || sectionRoot.querySelector('.filter-groups');
    if (!currentGroups || !newGroups) return;

    const openTitles = getOpenFilterGroupTitles();
    const nextChildren = Array.from(newGroups.childNodes);
    currentGroups.replaceChildren();
    nextChildren.forEach((child) => currentGroups.appendChild(child));
    restoreOpenFilterGroupTitles(openTitles);
    ensureMadesaRangeWidgetsReady(currentGroups);
  }

  function resetAllMadesaRangeWidgets(form) {
    if (!form) return;
    form.querySelectorAll('price-range').forEach((el) => {
      if (typeof el.resetFilterToDefault === 'function') {
        el.resetFilterToDefault();
      }
    });
    form.querySelectorAll('list-range').forEach((el) => {
      if (typeof el.resetFilterToDefault === 'function') {
        el.resetFilterToDefault();
      }
    });
  }

  function getSearchClearApplyQuery() {
    const raw = filterForm?.dataset?.searchClearUrl;
    if (!raw || String(raw).trim() === '') return null;
    try {
      const clearUrl = new URL(raw, window.location.href);
      const next = new URLSearchParams(clearUrl.search);
      let currentSort = null;
      try {
        currentSort = new URL(window.location.href).searchParams.get('sort_by');
      } catch (e) {
        currentSort = null;
      }
      if (currentSort) {
        next.set('sort_by', currentSort);
      }
      const s = next.toString();
      return s ? `?${s}` : '?';
    } catch (e) {
      return null;
    }
  }

  function updateURL(params) {
    const baseUrl = window.location.pathname;
    const newUrl = params ? `${baseUrl}?${params}` : baseUrl;
    window.history.pushState({ path: newUrl }, '', newUrl);
  }

  function showLoading() {
    const liveForm = getLiveFilterForm();
    const applyBtn = liveForm?.querySelector('.filter-footer-apply');
    const applyText = applyBtn?.querySelector('.filter-apply-text');
    const loadingIcon = applyBtn?.querySelector('.filter-loading');
    const currentProductList = getScopedProductList();

    if (applyText) applyText.style.display = 'none';
    if (loadingIcon) loadingIcon.style.display = 'inline-block';
    if (applyBtn) applyBtn.disabled = true;

    if (currentProductList) {
      currentProductList.style.opacity = '0.5';
      currentProductList.style.pointerEvents = 'none';
    }
  }

  function hideLoading() {
    const liveForm = getLiveFilterForm();
    const applyBtn = liveForm?.querySelector('.filter-footer-apply');
    const applyText = applyBtn?.querySelector('.filter-apply-text');
    const loadingIcon = applyBtn?.querySelector('.filter-loading');
    const currentProductList = getScopedProductList();

    if (applyText) applyText.style.display = 'inline';
    if (loadingIcon) loadingIcon.style.display = 'none';
    if (applyBtn) applyBtn.disabled = false;

    if (currentProductList) {
      currentProductList.style.opacity = '1';
      currentProductList.style.pointerEvents = 'all';
    }
  }

  function revealQuickFilters(bar) {
    const root = bar || document.getElementById('madesa-quick-filters');
    if (!root || !root.hidden) return;

    const started = Date.now();
    const timer = window.setInterval(() => {
      const form = document.getElementById('madesa-filter-form');
      const slider = root.querySelector('card-slider');
      const narrowOverflow = window.matchMedia('(max-width: 749px)').matches && slider?.dataset.overflowScroll === 'true';
      const carouselReady = typeof window.Carousel === 'function' && slider && slider.carousel;
      const expired = Date.now() - started > 4000;

      if (!form || !slider || (!narrowOverflow && !carouselReady)) {
        if (expired) window.clearInterval(timer);
        return;
      }

      window.clearInterval(timer);
      root.hidden = false;
      if (!narrowOverflow) {
        requestAnimationFrame(() => {
          if (typeof slider.carousel.updateMetrics === 'function') {
            slider.carousel.updateMetrics();
          }
        });
      }
    }, 50);
  }

  function updateQuickFilters(sectionRoot) {
    if (!sectionRoot) return;
    const current = document.getElementById('madesa-quick-filters');
    const next = sectionRoot.querySelector('#madesa-quick-filters');
    if (!current || !next || current === next) return;
    current.replaceWith(next);
    revealQuickFilters(next);
  }

  function applyQuickFilterSelection(bar, activeButton) {
    const form = getLiveFilterForm();
    if (!form || !bar) return;

    const selectedByParam = new Map();
    bar.querySelectorAll('[data-quick-filter]').forEach((btn) => {
      const paramName = btn.dataset.paramName;
      if (!paramName || selectedByParam.has(paramName)) return;
      selectedByParam.set(paramName, null);
    });

    if (activeButton?.dataset.paramName) {
      selectedByParam.set(activeButton.dataset.paramName, activeButton.dataset.value || '');
    }

    form.querySelectorAll('input.filter-input[type="checkbox"]').forEach((input) => {
      if (!selectedByParam.has(input.name)) return;
      const selected = selectedByParam.get(input.name);
      input.checked = selected != null && input.value === selected;
    });

    bar.querySelectorAll('[data-quick-filter], [data-quick-filter-clear]').forEach((btn) => {
      const on = activeButton ? btn === activeButton : btn.hasAttribute('data-quick-filter-clear');
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    applyFilters();
  }

  async function applyFilters(customParams = null) {
    const liveFilterForm = document.getElementById('madesa-filter-form');
    if (!liveFilterForm) return;

    const searchCollectionMode = typeof isSearchCollectionHydrateMode === 'function' && isSearchCollectionHydrateMode();
    
    if (searchCollectionMode) {
      await hydrateFiltersFromCollection();
    }

    const sectionIdValue = getSectionId();
    if (!sectionIdValue && !searchCollectionMode) {
      console.error('Madesa filters: section id not found');
      return;
    }

    syncMadesaManualRangeInputs(liveFilterForm);
    showLoading();
    
    const params = customParams || getFormData();
    if (customParams) {
      restorePriceRangeInputNames(liveFilterForm);
    }

    let fetchUrl;
    if (searchCollectionMode) {
      fetchUrl = buildCollectionProductsFetchUrl(params);
    } else {
      fetchUrl = buildFilterRequestUrl(params, sectionIdValue);
    }

    try {
      const response = await fetch(fetchUrl, { cache: 'no-store' });
      if (!response.ok) {
        throw new Error(`Filter request failed with status ${response.status}`);
      }
      const html = await response.text();
      
      let sectionRoot;
      if (searchCollectionMode) {
        sectionRoot = parseCollectionSectionResponse(html);
      } else {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        sectionRoot = getRenderedSectionRoot(tempDiv, sectionIdValue);
      }

      const currentProductList = getScopedProductList();

      if (searchCollectionMode) {
        applyHydratedFilterSection(sectionRoot);
        applySearchCollectionListingFromSection(sectionRoot);
      } else {
        const newProductList =
          sectionRoot.querySelector('.madesa-products-container .madesa-product-list') ||
          sectionRoot.querySelector('#madesa-product-list') ||
          sectionRoot.querySelector('.madesa-product-list');
          
        if (newProductList && currentProductList) {
          currentProductList.innerHTML = newProductList.innerHTML;
          if (currentProductList.closest('.madesa-search-results')) {
            currentProductList.dispatchEvent(new CustomEvent('madesa:search-list-refresh', { bubbles: false }));
          }
        } else if (!newProductList) {
          console.error('Madesa filters: product list not found in section response');
        }

        const currentPagination = getScopedPagination();
        const newPagination = sectionRoot.querySelector('#madesa-pagination');
        if (currentPagination) {
          if (newPagination) {
            currentPagination.innerHTML = newPagination.innerHTML;
            currentPagination.style.display = '';
          } else {
            currentPagination.style.display = 'none';
          }
        }

        updateCollectionCount(sectionRoot);

        try {
          updateFilterGroups(sectionRoot);
        } catch (filterPanelError) {
          console.error('Madesa filters: failed to refresh filter groups', filterPanelError);
        }

        const activeFiltersContainer = document.getElementById('madesa-active-filters');
        const newActiveFilters = sectionRoot.querySelector('#madesa-active-filters');
        
        if (activeFiltersContainer) {
          if (newActiveFilters) {
            activeFiltersContainer.innerHTML = newActiveFilters.innerHTML;
          } else {
            const checkboxes = liveFilterForm.querySelectorAll('input[type="checkbox"]:checked');
            const priceInputs = liveFilterForm.querySelectorAll('.filter-price-input');
            const hasFilters = checkboxes.length > 0 || Array.from(priceInputs).some(input => input.value);
            
            if (hasFilters) {
              let activeFiltersHTML = '<div class="filter-active-section">';
              activeFiltersHTML += '<h5 class="filter-active-title">' + filterStrings.active_filters_title + '</h5>';
              activeFiltersHTML += '<div class="filter-active-list">';
              
              checkboxes.forEach(checkbox => {
                const label = checkbox.closest('.filter-item')?.querySelector('.filter-label')?.textContent || checkbox.value;
                const filterGroup = checkbox.closest('.filter-group')?.querySelector('.filter-group-title')?.textContent || '';
                activeFiltersHTML += `
                  <button type="button" class="filter-active-tag" data-filter-value="${checkbox.value}">
                    <span>${filterGroup}: ${label}</span>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M12 4L4 12M4 4L12 12" stroke="#A4ADA8" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                  </button>
                `;
              });
              
              const clearHref = liveFilterForm.dataset.searchClearUrl || liveFilterForm.dataset.collectionUrl || '';
              activeFiltersHTML += '<a href="' + clearHref + '" class="filter-clear-all">' + filterStrings.clear_all + '</a>';
              activeFiltersHTML += '</div></div>';
              
              activeFiltersContainer.innerHTML = activeFiltersHTML;
              
              activeFiltersContainer.querySelectorAll('.filter-active-tag').forEach(tag => {
                tag.addEventListener('click', () => {
                  const filterValue = tag.dataset.filterValue;
                  const checkbox = liveFilterForm.querySelector(`input[value="${filterValue}"]`);
                  if (checkbox) {
                    checkbox.checked = false;
                    applyFilters();
                  }
                });
              });
            } else {
              activeFiltersContainer.innerHTML = '';
            }
          }
        }
        
        const filterHeaderBadge = document.querySelector('.filter-header-content .filter-count-badge');
        const newFilterHeader = sectionRoot.querySelector('.filter-header-content');
        const newHeaderBadge = newFilterHeader?.querySelector('.filter-count-badge');
        if (filterHeaderBadge && newHeaderBadge) {
          filterHeaderBadge.textContent = newHeaderBadge.textContent;
          filterHeaderBadge.style.display = 'flex';
        } else if (filterHeaderBadge && !newHeaderBadge) {
          filterHeaderBadge.style.display = 'none';
        } else if (!filterHeaderBadge && newHeaderBadge) {
          const headerContent = document.querySelector('.filter-header-content');
          if (headerContent) {
            const badge = document.createElement('span');
            badge.className = 'filter-count-badge';
            badge.textContent = newHeaderBadge.textContent;
            headerContent.appendChild(badge);
          }
        }

        const newTriggerBadge = sectionRoot.querySelector('.madesa-filter-trigger .filter-count-badge');
        const triggerBadge = document.querySelector('.madesa-filter-trigger .filter-count-badge');
        if (triggerBadge) {
          if (newTriggerBadge) {
            triggerBadge.textContent = newTriggerBadge.textContent;
            triggerBadge.style.display = '';
          } else {
            triggerBadge.style.display = 'none';
          }
        }
      }
      
      updateQuickFilters(sectionRoot);
      
      const baseUrlStr = liveFilterForm.dataset.collectionUrl || window.location.pathname;
      if (customParams) {
        window.history.pushState({}, '', baseUrlStr + (String(customParams).startsWith('?') ? customParams : `?${customParams}`));
      } else {
        updateURL(params);
      }
      
      currentProductList?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      
    } catch (error) {
      console.error('Error applying filters:', error);
    } finally {
      hideLoading();
      scheduleSearchWishlistRefresh();
    }
  }

  function refreshSearchWishlistButtons() {
    const root = document.querySelector('results-list.madesa-search-results');
    if (!root) return;

    root.querySelectorAll('.wishlist-btn[data-gridHulkList]').forEach((btn) => {
      btn.classList.add('hulkapps-wishlist-btn-enabled', 'grid-wishlist-btn');
      btn.style.removeProperty('background');
      btn.style.removeProperty('display');
    });

    const sectionId = root.getAttribute('section-id');
    if (sectionId) {
      const sid = sectionId.replace(/^shopify-section-/, '');
      root.dispatchEvent(
        new CustomEvent('shopify:section:load', {
          bubbles: true,
          detail: { sectionId: `shopify-section-${sid}` },
        })
      );
    }
  }

  function scheduleSearchWishlistRefresh() {
    if (!document.querySelector('results-list.madesa-search-results')) return;
    setTimeout(refreshSearchWishlistButtons, 300);
    setTimeout(refreshSearchWishlistButtons, 1500);
  }

  function updateFilterCount() {
    let count = 0;
    filterForm.querySelectorAll('input[type="checkbox"]:checked').forEach((cb) => {
      if (cb.closest('.list-range-hidden-values')) return;
      count++;
    });

    filterForm.querySelectorAll('list-range').forEach((lr) => {
      const minR = lr.querySelector('.madesa-range-min') || lr.querySelector('#range-min');
      const maxR = lr.querySelector('.madesa-range-max') || lr.querySelector('#range-max');
      if (!minR || !maxR) return;
      const minV = parseInt(minR.value, 10);
      const maxV = parseInt(maxR.value, 10);
      const lo = parseInt(minR.getAttribute('min') || '0', 10);
      const hi = parseInt(maxR.getAttribute('max') || '0', 10);
      if (minV > lo || maxV < hi) {
        count++;
      }
    });

    const priceInputs = filterForm.querySelectorAll('.filter-price-input');
    const hasPriceFilter = Array.from(priceInputs).some((input) => input.value);
    if (hasPriceFilter) count++;
    
    // Update badges
    const badges = document.querySelectorAll('.filter-count-badge');
    badges.forEach(badge => {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    });
    
    // Update apply button text
    const applyText = filterForm.querySelector('.filter-apply-text');
    if (applyText) {
      applyText.textContent = filterStrings.apply_filters;
    }
  }

  // Form submission
  filterForm.addEventListener('submit', (e) => {
    e.preventDefault();
    applyFilters();
    if (!isDesktop()) {
      closeDrawer();
    }
  });

  // Auto-apply on checkbox change (desktop only)
  filterForm.addEventListener('change', (e) => {
    if (e.target.classList.contains('filter-input') && e.target.type === 'checkbox') {
      updateFilterCount();
      // Auto-submit on checkbox change for desktop
      if (isDesktop()) {
        debounce(() => {
          applyFilters();
        }, 300, 'checkbox');
      }
    }
  });

  // Auto-apply on price input change
  filterForm.addEventListener('input', (e) => {
    if (e.target.classList.contains('filter-price-input')) {
      updateFilterCount();
      if (isDesktop()) {
        debounce(() => {
          applyFilters();
        }, 800, 'price');
      }
    }
  });

  // Clear filters
  clearFiltersBtn?.addEventListener('click', () => {
    resetAllMadesaRangeWidgets(filterForm);

    const checkboxes = filterForm.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((cb) => {
      cb.checked = false;
    });

    const priceInputs = filterForm.querySelectorAll('.filter-price-input');
    priceInputs.forEach((input) => {
      input.value = '';
    });

    const searchOnlyClear = getSearchClearApplyQuery();
    if (searchOnlyClear != null) {
      applyFilters(searchOnlyClear);
    } else {
      applyFilters();
    }

    updateFilterCount();

    if (!isDesktop()) {
      closeDrawer();
    }
  });

  document.addEventListener('click', (e) => {
    const clearBtn = e.target.closest('[data-quick-filter-clear]');
    const chip = clearBtn ? null : e.target.closest('[data-quick-filter]');
    const button = clearBtn || chip;
    if (!button) return;

    const bar = button.closest('#madesa-quick-filters');
    if (!bar || button.classList.contains('is-active')) return;

    e.preventDefault();
    applyQuickFilterSelection(bar, chip);
  });

  // Handle active filter tag removals
  document.addEventListener('click', (e) => {
    const link = e.target.closest('.filter-active-tag');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href) return;

    e.preventDefault();

    try {
      const targetUrl = new URL(href, window.location.href);
      const nextParams = targetUrl.search ? targetUrl.search : '';
      applyFilters(nextParams);
    } catch (error) {
      window.location.href = href;
    }
  });

  function initQuickFilterCollectionSlider(root) {
    if (!root || root.dataset.dragReady === 'true') return;

    const track = root.querySelector('.madesa-quick-filter-collections__track');
    const scrollbar = root.querySelector('.madesa-quick-filter-collections__scrollbar');
    const thumb = root.querySelector('.madesa-quick-filter-collections__scrollbar-thumb');
    if (!track || !scrollbar || !thumb) return;

    root.dataset.dragReady = 'true';

    const updateThumb = () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 1) {
        scrollbar.hidden = true;
        return;
      }

      scrollbar.hidden = false;
      let thumbWidth = (track.clientWidth / track.scrollWidth) * 100;
      if (thumbWidth < 10) thumbWidth = 10;
      if (thumbWidth > 25) thumbWidth = 25;
      const left = (track.scrollLeft / maxScroll) * (100 - thumbWidth);
      thumb.style.width = thumbWidth + '%';
      thumb.style.left = left + '%';
    };

    track.addEventListener('scroll', updateThumb, { passive: true });
    window.addEventListener('resize', updateThumb);
    if (typeof ResizeObserver === 'function') {
      const observer = new ResizeObserver(updateThumb);
      observer.observe(track);
    }
    track.querySelectorAll('img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', updateThumb, { once: true });
    });

    let dragging = false;
    let moved = false;
    let blockClick = false;
    let startX = 0;
    let startScroll = 0;

    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (event.target.closest('a.madesa-quick-filter-collection')) return;
      dragging = true;
      moved = false;
      startX = event.clientX;
      startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
      track.setPointerCapture(event.pointerId);
    });

    track.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      const delta = event.clientX - startX;
      if (Math.abs(delta) > 6) moved = true;
      track.scrollLeft = startScroll - delta;
    });

    const stopDrag = () => {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      if (moved) {
        blockClick = true;
        window.setTimeout(() => {
          blockClick = false;
        }, 250);
      }
    };

    track.addEventListener('pointerup', stopDrag);
    track.addEventListener('pointercancel', stopDrag);
    track.addEventListener('click', (event) => {
      if (!blockClick) return;
      if (event.target.closest('a.madesa-quick-filter-collection')) return;
      blockClick = false;
      event.preventDefault();
      event.stopPropagation();
    }, true);

    const scrollFromPointer = (clientX) => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 1) return;
      const rect = scrollbar.getBoundingClientRect();
      if (!rect.width) return;
      const ratio = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
      track.scrollLeft = ratio * maxScroll;
    };

    let barDragging = false;

    scrollbar.addEventListener('pointerdown', (event) => {
      if (event.button !== 0) return;
      event.preventDefault();
      barDragging = true;
      scrollbar.classList.add('is-dragging');
      scrollbar.setPointerCapture(event.pointerId);
      scrollFromPointer(event.clientX);
    });

    scrollbar.addEventListener('pointermove', (event) => {
      if (!barDragging) return;
      scrollFromPointer(event.clientX);
    });

    const stopBarDrag = () => {
      if (!barDragging) return;
      barDragging = false;
      scrollbar.classList.remove('is-dragging');
    };

    scrollbar.addEventListener('pointerup', stopBarDrag);
    scrollbar.addEventListener('pointercancel', stopBarDrag);

    updateThumb();
  }

  document.querySelectorAll('.madesa-quick-filter-collections').forEach(initQuickFilterCollectionSlider);

  // Initialize filter count on page load
  updateFilterCount();
  revealQuickFilters();
  scheduleSearchWishlistRefresh();

  if (isSearchCollectionHydrateMode()) {
    hydrateFiltersFromCollection().then(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const hasActiveFilters = [...urlParams.keys()].some(
        (key) => key.startsWith('filter.') || key === 'sort_by'
      );
      if (hasActiveFilters) {
        applyFilters(window.location.search);
      } else {
        bindSearchCollectionPaginationLinks();
      }
    });
  }

  // Sort functionality
  const sortSelect = document.getElementById('madesa-sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const sortValue = sortSelect.value;
      
      syncMadesaManualRangeInputs(filterForm);
      const filterParams = getFormData();
      
      // Build URL with both filters and sort
      const url = new URL(window.location.href);
      url.search = ''; // Clear existing params
      
      // Add filter params
      if (filterParams) {
        const params = new URLSearchParams(filterParams);
        params.forEach((value, key) => {
          url.searchParams.append(key, value);
        });
      }
      
      // Add sort param
      url.searchParams.set('sort_by', sortValue);
      
      // Apply with combined parameters
      applyFilters(url.search);
    });
  }
})();